import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import get from "@beeldit/core/services/get";
import { DetailsActionContext } from "./DetailsActionContext";
import getPageStructureLoadError from "@bloonde/cms/cms-pages/helpers/getPageStructureLoadError";

function useGet() {
  const {
    setBackendFormErrors,
    setElement,
    setPageLoadError,
    setSchema,
    setSchemaUI,
    setSelectedLang,
  } = useContext(DetailsActionContext);
  const errorHandler = useErrorHandler();

  return (
    id: any,
    onSuccess: any = (data: any) => {
      return data;
    }
  ) => {
    setPageLoadError(null);

    get("pages", id,'?relations=seo,sections,tags&appends=tag_ids')
      .then((response: any) => {
        let data = response.data;
        data = onSuccess(response.data);
        setBackendFormErrors({});
        setPageLoadError(null);
        setElement(data); 
        setSelectedLang("es");
      })
      .catch((error: any) => {
        const pageLoadError = getPageStructureLoadError(error);

        if (pageLoadError) {
          setBackendFormErrors({});
          setElement(null);
          setSchema(null);
          setSchemaUI(null);
          setPageLoadError(pageLoadError);
          return;
        }

        errorHandler(error, setBackendFormErrors);
      });
  };
}

export default useGet;
